import styled from 'styled-components';

export default styled.div`
  color: #919dac;
  margin-right: auto;
`;
